import { Dialog } from './Dialog'
import { TargetScores, TargetScoresProps } from './TargetScores'
import _ from 'lodash'
import { DashboardData, getDashboardData, getSessionKey } from '../api'
import { useEffect, useState } from 'react'
import { filterDashboardDataToDay } from '../utils/dataFormatting'
import { Moment } from 'moment'
import { Link } from '@mui/material'
import { calcStreaks } from '../utils/calcStreak'

interface TeammateTargetsDialogProps {
  playerId: string
  day: Moment
  onClose: () => void
}

export const TeammateTargetsDialog = ({
  playerId,
  day,
  onClose,
}: TeammateTargetsDialogProps) => {
  const [dashboardData, setDashboardData] = useState<DashboardData | null>(null)

  useEffect(() => {
    ;(async function () {
      const sessionKey = getSessionKey()
      setDashboardData(await getDashboardData(sessionKey, playerId))
    })()
  }, [playerId])

  if (!dashboardData) {
    return (
      <Dialog hasSubmitButton={false} onClose={onClose}>
        <div>Loading...</div>
      </Dialog>
    )
  } else {
    const dashboardDataForDay = filterDashboardDataToDay({
      dashboardData,
      day,
    })
    return (
      <TeammateTargetsDialogContents
        dashboardData={dashboardDataForDay}
        streaks={calcStreaks(dashboardData.scores)}
        onClose={onClose}
      />
    )
  }
}

type TeammateTargetsDialogContentsProps = TargetScoresProps &
  Pick<TeammateTargetsDialogProps, 'onClose'>

export const TeammateTargetsDialogContents = ({
  onClose,
  ...props
}: TeammateTargetsDialogContentsProps) => {
  const {
    dashboardData: { player, teammate },
  } = props

  return (
    <Dialog
      title={`${_.startCase(props.dashboardData.player.firstName)}'s Scores`}
      hasSubmitButton={false}
      onClose={onClose}
    >
      <TargetScores {...props} isViewOnly={true} />
    </Dialog>
  )
}
